module.exports = __webpack_public_path__ + "static/media/bg.abcaab8d.png";